import cssMobile from '../../../css/editorMobile.module.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus, faSpinner} from '@fortawesome/free-solid-svg-icons'
import {useTranslation} from 'react-i18next'

interface OverflowModalProps {
  closed: boolean
  closeModal: () => void
  addToCart: () => void
  showAddTocart?: boolean
  loading?: boolean
}

export default function OverflowModal({
  closed,
  closeModal,
  addToCart,
  showAddTocart = false,
  loading,
}: OverflowModalProps) {
  const {t} = useTranslation()
  return (
    <div className={`${cssMobile.modal} ${closed ? cssMobile.closed : ''}`}>
      <div className={cssMobile.modalHeader}>
        <FontAwesomeIcon
          icon={faPlus}
          size="2x"
          style={{transform: 'rotate(45deg)'}}
          onClick={closeModal}
        />
      </div>
      <div className={cssMobile.modalBody}>
        <div className={cssMobile.overflowModalContent}>
          <p>{t('A szerkesztőterületről kilógó grafikák le lesznek vágva!')}</p>
          <div className={cssMobile.buttonRow}>
            <button
              className="editorButton"
              style={{marginLeft: '1rem'}}
              onClick={closeModal}>
              {t('Vissza')}
            </button>
            {showAddTocart && (
              <button
                disabled={loading}
                className="editorButton addToCartButton"
                style={{marginLeft: '1rem'}}
                onClick={addToCart}>
                {loading ? (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    className={cssMobile.spinner}
                  />
                ) : (
                  t('Kosárba')
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
